export enum TypeGraph {
  WATERLEVEL = 'WATERLEVEL',
  TEMPERATURE = 'TEMPERATURE',
}
